<template>
  <div :class="$style.container" @keydown.enter="handleSubmit('message')">
    <Form :model="form" label-position="left" :label-width="0" class="messageLogin" :rules="rules" ref="message">
        <FormItem prop="phone">
          <Input v-model="form.phone" placeholder="输入手机号码"/>
        </FormItem>
        <FormItem prop="code">
          <Input v-model="form.code" placeholder="输入短信验证码" style="width:201px;"/>
          <Button type="primary" :class="[$style.code, $style.active]" @click.stop="handleGetCode" v-if="isSendCode && !isCounter" style="opacity:1;color:#fff;">获取验证码</Button>
          <Button type="primary" :class="$style.code" v-else>{{msg}}</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click.stop="handleSubmit('message')">注册/登录</Button>
        </FormItem>
        <FormItem :class="$style.entry" style="margin-top:20px;">
          <span :class="$style.pwdLogin" @click.stop="changePwdLogin">使用密码登录</span>
        </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
  data() {
    let validatePhone = (rule, value, callback) => {
      if (value === '') {
          callback(new Error('请输入您的手机号码'));
      } else {
          if (!(/^1[345789]\d{9}$/.test(this.form.phone))) {
              callback('请输入正确的手机号码'); 
          }
          callback();
      }
    }
    return {
      form:{
        phone:'',
        code: ''
      },
      single: false,
      isCounter: false, // 是否点击过获取验证码
      msg: '获取验证码',
      timer: null,
      rules: {
        phone: [
          { validator: validatePhone, trigger: "blur"},
        ],
        code: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
          {type: 'string', min: 4, max:6, message: '请输入正确的验证码', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    isSendCode () {
      if (this.form.phone) {
        return true
      }
      return false
    }
  },
  methods: {
    // 提交
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('login',{account:this.form.phone,code: this.form.code },'03')
        } else {
         return false
        }
      })
    },
    // 切换到密码登录
    changePwdLogin () {
      this.$emit('pwdLogin')
    },
    beforeDestory () {
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    // 获取验证码
    handleGetCode () {
      this.isCounter = true
      let count = 60
      this.msg = `${count} s`
      this.sendCode()
      this.timer = setInterval(() => {
        count--
        if (count === 0) {
          this.isCounter = false
          clearInterval(this.timer)
          this.timer = null
        }
        this.msg = `${count} s`
      },1000)
    },
    // 发送验证码
    async sendCode () {
      try {
        let params = {
          mobile: this.form.phone,
          type: "0018",
          url:window.location.hostname
        }
        let res = await this.$http.get(`${this.baseURL}/ec/book/sendVerificationCode1`, {params})
        if (res.data.code === 200) {

        } else {
          this.isCounter = false
          clearInterval(this.timer)
          this.timer = null
        }
      } catch(err) {
        console.log('send code fail:',err)
      }
    },
    // 重置表单
    resetForm () {
      this.form ={
        phone:'',
        code: ''
      }
    }
  }
};
</script> 
<style lang="less" module>
.container {
  form {
    width: 300px;
    margin: 0 auto;
  }
  input {
    width:100%;
    border: none;
    border-bottom: 1px solid #B4CAF7;
    font-size:14px;
  }
  button {
    width: 100%;
    height: 40px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    background: #4B7FF0;
  }
  .code {
    float: right;
    height:32px;
    width: 86px;
    opacity: 0.4;
    background: #D7DBDE;
    border-radius: 2px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #999999;
    padding: 0;
    border-color: #D7DBDE;
  }
  .active {
      background: #4B7FF0;
      border-color:#4B7FF0;
      color:#fff;
    }
  .entry {
    text-align: center;
    .pwdLogin {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #999999;
      cursor: pointer;
    }
  }
 
}
</style>

<style scoped>
  .messageLogin >>> .ivu-form-item {
    margin-top: 40px;
    margin-bottom: 0px;
  }
  .messageLogin >>> .ivu-input:hover, .messageLogin >>> .ivu-input:focus {
    border-color: #fff;
    border-bottom: 1px solid #B4CAF7;
    box-shadow:none;
  }
  .messageLogin >>> .ivu-form-item-error .ivu-input {
    border:none;
    border-bottom: 1px solid #B4CAF7;
  }
</style>